"use client"
import { SiteNavigation } from "trimble-terra";
import React, { useState, Suspense, useEffect, useRef } from "react"
import "./SiteNavigation.css";
import Loading from "./loading";

export default function FormatSiteNavigation(props: any) {
  const { data, profile, config, languageSettings, saveLanguageSettings, siteLangs } = props;

  const [currentOpenMegaMenu, setCurrentOpenMegaMenu] = useState(null)
  const [mobileNavOpen, setMobileNavOpen] = useState(null)
  const [languageSelectorDeployed, setLanguageSelectorDeployed] = useState(false)
  const navRef = useRef<any>();

  const handleLanguageSelectorDeployed = () => {
    setLanguageSelectorDeployed(!languageSelectorDeployed)
  }

  const saveLanguage = (newLanguage: any) => {
    saveLanguageSettings(newLanguage)
  }

  const cleanURL = (item: any, locale: string = 'en-US') => {
    let additionalSegment = ``
    if(item?.pageLink?.__typename === 'PageProductPage') {
      // console.log("cleanURL: PageProductPage", item?.pageLink?.slug)
      additionalSegment = `/products`
    }
    let urlLocale = 'en'
    let url = ""
    if(item?.pageLink?.url) {
      url = `${item?.pageLink?.url}`
      // if the URL starts with the NAV_BASE_URL, remove it, because we want it to be a relative URL
      if(url?.startsWith(profile.NAV_BASE_URL)) {
        url = url.replace(profile.NAV_BASE_URL, '')
      }
    } else if (item?.pageLink?.slug) {
      url = `/${urlLocale}${additionalSegment}/${item?.pageLink?.slug}`
    } else {
      url = `${item?.pageLink?.externalUrl}`
    }
    if(profile.DEPLOYMENT_ENV === 'development') {
      if(url?.startsWith('/')) {
        url = `${baseUrl}${url}`
      }
    }
    return url
  }


  // Use NAV_BASE_URL if you want a separate URL for items in the nav
  const baseUrl = profile.NAV_BASE_URL ? profile.NAV_BASE_URL : profile.BASE_URL ? profile.BASE_URL : "https://www.trimble.com";

  let navCtaData:any = {
    text: data?.navCta?.title || "",
    url: cleanURL(data?.navCta),
  }

  if(navCtaData.text == "") {
    navCtaData = null
  }

  const formattedSiteNavData = {
    
    navItems: data?.navigationItemsCollection?.items?.map((item: any) => {
      let promoData:any = {
        title: item?.featuredPromo?.title,
        description:
          item?.featuredPromo?.description,
        pageLink: {
          url: cleanURL(item?.featuredPromo),
          text: item?.featuredPromo?.pageLinkLabel || item?.featuredPromo?.pageLink?.text,
        },
        image: {
          src: item?.featuredPromo?.image?.image?.url,
          altText: item?.featuredPromo?.image?.altText,
        },
      }
      if(item.featuredPromo == null || item.featuredPromo == undefined) {
        promoData = null
      }


      return {
        contentfulId: item?.sys?.id,
        text: item?.title,
        url: cleanURL(item),
        type: item?.navigationItemsCollection?.items?.length > 0 ? "category" : "link",
        links: item?.navigationItemsCollection?.items?.map((secondaryItem: any) => {
          let subCategoryLinkData = null
          if(secondaryItem?.subCategoryLink?.title) {
            subCategoryLinkData= {
              text: secondaryItem?.subCategoryLink?.title,
              description: secondaryItem?.subCategoryLink?.description,
              url: cleanURL(secondaryItem?.subCategoryLink) 
            }
          }
          return {
            contentfulId: secondaryItem?.sys?.id,
            text: secondaryItem?.title,
            type: secondaryItem?.navigationItemsCollection?.items?.length > 0 ? "category" : "link",
            description: secondaryItem?.description,
            subCategoryLink: subCategoryLinkData,
            url: cleanURL(secondaryItem),
            links: secondaryItem?.navigationItemsCollection?.items?.map((tertiaryItem: any) => {
              return {
                text: tertiaryItem?.title,
                type: "link",
                description: tertiaryItem?.description,
                contentfulId: tertiaryItem?.sys?.id,
                url: cleanURL(tertiaryItem),
              }
            })
          }
        }),
        categoryLink: {
          text: item?.categoryLink?.title,
          description: item?.categoryLink?.description,
          url: `${baseUrl}/en/${item?.categoryLink?.pageLink?.slug}` 
        },
        navCategoryPromo: promoData
      }
    }),
    navCta: navCtaData,
    currentOpenMegaMenu: currentOpenMegaMenu,
    setCurrentOpenMegaMenu: setCurrentOpenMegaMenu,
    mobileNavOpen: mobileNavOpen,
    setMobileNavOpen: setMobileNavOpen,
    languageSelectorData: {
      labels: {
        language: config?.commonTextLabels?.labelForLanguageSwitcher || "LANGUAGE",
        buttons: {
          ok: config?.commonTextLabels?.labelForAccept || "OK",
          cancel: config?.commonTextLabels?.labelForCancel || "Cancel",
        },
      },
      settings: languageSettings,
      languages: siteLangs
    }
  }
  const mainLogo = {
    src: data?.logo?.image?.url,
    url: baseUrl,
    altText: data?.logo?.image?.altText,
  }

  const alternativeLogo = {
    src: data?.alternativeLogo?.image?.url,
    url: baseUrl,
    altText: data?.alternativeLogo?.image?.altText,
  }

  const logoToUse = data?.logoVariant === 'Alternative' && alternativeLogo?.url ? alternativeLogo : mainLogo;

  useEffect(() => {
    const closeAllDropDowns = (e: any) => {
      if(navRef?.current){
        if(languageSelectorDeployed != false) {
          setLanguageSelectorDeployed(!languageSelectorDeployed)
        } 
        // setSectorFlyoutOpen(false);
        if (!navRef?.current?.contains(e?.target)) {
          setCurrentOpenMegaMenu(null)
        }
      }
    }
    if (typeof window !== "undefined") {
      window.addEventListener("click", e => closeAllDropDowns(e))
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", e => closeAllDropDowns(e))
      }
    }
  }, []) // breaks dropdown  languageSelectorDeployed


  const siteName = (process.env.NEXT_PUBLIC_PROFILE == 'preview') ? 'Preview' : data?.sectorName || null

  return (
    <Suspense fallback={<Loading />}>
      <div className="rc-site-navigation" ref={navRef}>
        <SiteNavigation 
          mainNavMenu={formattedSiteNavData} 
          logo={logoToUse}
          logoVariant={data?.logoVariant || "Standard"}
          sectorName={siteName}
          utilityNavMenu={{
            languageSelectorData: formattedSiteNavData?.languageSelectorData,
            setLanguageSelectorDeployed: setLanguageSelectorDeployed,
            languageSelectorDeployed: languageSelectorDeployed,
            handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
            saveLanguage: saveLanguage,
            disableCartFlyout: true
          }}
        />
      </div>
    </Suspense>
  )
}